var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Tooltip from '../Tooltip';
import Chip from '../Chip';
import Span from '../Span';
import { Stack } from '../Stack';
const ShortcutTooltip = (_a) => {
    var { title, keys, children } = _a, tooltipProps = __rest(_a, ["title", "keys", "children"]);
    return (_jsx(Tooltip, Object.assign({ title: title, text: _jsx(Stack, { direction: 'row', spacing: 0.5, children: Array.isArray(keys) ? (keys.map((keyLabel, index) => (_jsxs(React.Fragment, { children: [index > 0 && _jsx(Span, { children: "+" }), _jsx(Chip, { label: keyLabel, color: 'primary', variant: 'two-tone', size: 'small' }, keyLabel)] }, keyLabel)))) : (_jsx(Chip, { color: 'primary', size: 'small', variant: 'two-tone', label: keys })) }) }, tooltipProps, { children: children })));
};
export default ShortcutTooltip;
